import { clearWorkletCachesForCtx } from './bufferTransport/worklets';
import { userGestureSeen, resumeCtxOnGesture } from './orchestrator/autoplayGate';
// Enforce a single AudioContext/Worklet VM for the entire session and track its generation
let ctx: AudioContext | null = null;
let gen = 0;

function attachCtxCloseHandler(c: AudioContext) {
  try {
    c.addEventListener('statechange', () => {
      try { if (c.state === 'closed') { clearWorkletCachesForCtx(c); } } catch {}
    });
  } catch {}
}

export function getCtx(): AudioContext {
  if (ctx && ctx.state !== 'closed') return ctx;
  const C = (window as any).AudioContext || (window as any).webkitAudioContext;
  ctx = new C();
  attachCtxCloseHandler(ctx as AudioContext);
  gen++;
  return ctx!;
}

export function getCtxGen(): number { return gen; }

export async function replaceCtx(): Promise<AudioContext> {
  const old = ctx;
  ctx = null;
  try { clearWorkletCachesForCtx(old as any); } catch {}
  try { await old?.close(); } catch {}
  // Give the AW global scope a moment to teardown fully
  try { await new Promise<void>(r => setTimeout(r, 150)); } catch {}
  const C = (window as any).AudioContext || (window as any).webkitAudioContext;
  ctx = new C();
  attachCtxCloseHandler(ctx as AudioContext);
  gen++;
  try {
    if (userGestureSeen()) { await (ctx as AudioContext).resume().catch(() => {}); }
    else { void resumeCtxOnGesture(ctx as AudioContext); }
  } catch {}
  return ctx!;
}

export function ctxOk(c: AudioContext | null | undefined) {
  return !!c && c.state !== 'closed';
}

export default getCtx;
